var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.8126,
    cy: 75.9376,
    r: 47.0089,
    fill: "#FFE7E7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.7501,
    cy: 44.1964,
    r: 2.94643,
    fill: "#FFE7E7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.955,
    cy: 32.5448,
    r: 5.49107,
    fill: "#FFE7E7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.6876,
    cy: 106.206,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.17,
    cy: 101.116,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.991,
    cy: 107.009,
    r: 2.54464,
    fill: "#FFE7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.3195 30.9476C85.1642 30.9145 85.1642 30.6929 85.3195 30.6599L87.6674 30.1606C87.724 30.1485 87.7683 30.1044 87.7806 30.0479L88.2861 27.7165C88.3196 27.562 88.54 27.562 88.5735 27.7165L89.0791 30.0479C89.0914 30.1044 89.1356 30.1485 89.1922 30.1606L91.5402 30.6599C91.6955 30.6929 91.6955 30.9145 91.5402 30.9476L89.1922 31.4469C89.1356 31.4589 89.0914 31.503 89.0791 31.5595L88.5735 33.8909C88.54 34.0455 88.3196 34.0455 88.2861 33.8909L87.7806 31.5595C87.7683 31.503 87.724 31.4589 87.6674 31.4469L85.3195 30.9476Z",
    fill: "#F8AFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4883 82.9343C21.5482 82.6511 21.9524 82.6511 22.0124 82.9343L22.9078 87.1645C22.9296 87.2676 23.0098 87.3483 23.1128 87.3707L27.2993 88.2827C27.5804 88.344 27.5804 88.7449 27.2993 88.8062L23.1128 89.7182C23.0098 89.7406 22.9296 89.8213 22.9078 89.9244L22.0124 94.1546C21.9524 94.4378 21.5482 94.4378 21.4883 94.1546L20.5929 89.9244C20.5711 89.8213 20.4908 89.7406 20.3878 89.7182L16.2014 88.8062C15.9203 88.7449 15.9203 88.344 16.2014 88.2827L20.3878 87.3707C20.4908 87.3483 20.5711 87.2676 20.5929 87.1645L21.4883 82.9343Z",
    fill: "#F8AFAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.824 45.4343C119.884 45.1511 120.288 45.1511 120.348 45.4343L120.871 47.9021C120.893 48.0052 120.973 48.0859 121.076 48.1083L123.525 48.6419C123.806 48.7032 123.806 49.1041 123.525 49.1653L121.076 49.6989C120.973 49.7214 120.893 49.8021 120.871 49.9052L120.348 52.3729C120.288 52.6561 119.884 52.6561 119.824 52.373L119.302 49.9052C119.28 49.8021 119.2 49.7214 119.097 49.6989L116.648 49.1653C116.367 49.1041 116.367 48.7032 116.648 48.6419L119.097 48.1083C119.2 48.0859 119.28 48.0052 119.302 47.9021L119.824 45.4343Z",
    fill: "#F8AFAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.623 84.999L131.443 88.8742L135.263 89.7064L131.443 90.5385L130.623 94.4137L129.803 90.5385L125.983 89.7064L129.803 88.8742L130.623 84.999Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.0469,
    y: 47.0343,
    width: 49.3587,
    height: 53.1383,
    rx: 2.87373,
    transform: "rotate(10 75.0469 47.0343)",
    fill: "white",
    stroke: "#F8AFAF",
    strokeWidth: 1.09559
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.4053,
    y: 50.4025,
    width: 43.2531,
    height: 37.729,
    rx: 2.87373,
    transform: "rotate(10 77.4053 50.4025)",
    fill: "#FFE7E7",
    stroke: "#FFE7E7",
    strokeWidth: 1.09559
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3439,
    y: 55.6055,
    width: 49.3587,
    height: 53.1383,
    rx: 2.87373,
    transform: "rotate(-10 27.3439 55.6055)",
    fill: "white",
    stroke: "#F8AFAF",
    strokeWidth: 1.09559
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7121,
    y: 57.9639,
    width: 43.2531,
    height: 37.729,
    rx: 2.87373,
    transform: "rotate(-10 30.7121 57.9639)",
    fill: "#FFE7E7",
    stroke: "#FFE7E7",
    strokeWidth: 1.09559
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5933,
    y: 42.6817,
    width: 58.8699,
    height: 63.3944,
    rx: 3.3321,
    fill: "white",
    stroke: "#F8AFAF",
    strokeWidth: 1.09559
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 51.0738,
    y: 46.1622,
    width: 51.5611,
    height: 44.9484,
    rx: 3.3321,
    fill: "#FFE7E7",
    stroke: "#F8AFAF",
    strokeWidth: 1.09559
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4253 82.8145H72.9287",
    stroke: "#FFD3D2",
    strokeWidth: 1.09559,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.228 84.9414H77.924",
    stroke: "#FFD3D2",
    strokeWidth: 1.09559,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7549 85.0342H67.9343",
    stroke: "#FFD3D2",
    strokeWidth: 1.09559,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4321 83H90.6866",
    stroke: "#FFD3D2",
    strokeWidth: 1.09559,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9091 61.2273H80.2727C80.5621 61.2273 80.8395 61.1123 81.0441 60.9078C81.2487 60.7032 81.3636 60.4257 81.3636 60.1364C81.3636 59.847 81.2487 59.5696 81.0441 59.365C80.8395 59.1604 80.5621 59.0455 80.2727 59.0455H78.0909V57.9545C78.0909 57.6652 77.976 57.3877 77.7714 57.1832C77.5668 56.9786 77.2893 56.8636 77 56.8636C76.7107 56.8636 76.4332 56.9786 76.2286 57.1832C76.024 57.3877 75.9091 57.6652 75.9091 57.9545V59.0455C75.0411 59.0455 74.2087 59.3903 73.5949 60.004C72.9812 60.6178 72.6364 61.4502 72.6364 62.3182C72.6364 63.1862 72.9812 64.0186 73.5949 64.6323C74.2087 65.2461 75.0411 65.5909 75.9091 65.5909H78.0909C78.3802 65.5909 78.6577 65.7058 78.8623 65.9104C79.0669 66.115 79.1818 66.3925 79.1818 66.6818C79.1818 66.9711 79.0669 67.2486 78.8623 67.4532C78.6577 67.6578 78.3802 67.7727 78.0909 67.7727H73.7273C73.4379 67.7727 73.1605 67.8877 72.9559 68.0922C72.7513 68.2968 72.6364 68.5743 72.6364 68.8636C72.6364 69.153 72.7513 69.4304 72.9559 69.635C73.1605 69.8396 73.4379 69.9545 73.7273 69.9545H75.9091V71.0455C75.9091 71.3348 76.024 71.6123 76.2286 71.8168C76.4332 72.0214 76.7107 72.1364 77 72.1364C77.2893 72.1364 77.5668 72.0214 77.7714 71.8168C77.976 71.6123 78.0909 71.3348 78.0909 71.0455V69.9545C78.9589 69.9545 79.7913 69.6097 80.4051 68.996C81.0188 68.3822 81.3636 67.5498 81.3636 66.6818C81.3636 65.8138 81.0188 64.9814 80.4051 64.3676C79.7913 63.7539 78.9589 63.4091 78.0909 63.4091H75.9091C75.6198 63.4091 75.3423 63.2942 75.1377 63.0896C74.9331 62.885 74.8182 62.6075 74.8182 62.3182C74.8182 62.0289 74.9331 61.7514 75.1377 61.5468C75.3423 61.3422 75.6198 61.2273 75.9091 61.2273ZM77 52.5C74.6266 52.5 72.3066 53.2038 70.3332 54.5224C68.3598 55.8409 66.8217 57.7151 65.9135 59.9078C65.0052 62.1005 64.7676 64.5133 65.2306 66.8411C65.6936 69.1689 66.8365 71.307 68.5147 72.9853C70.193 74.6635 72.3311 75.8064 74.6589 76.2694C76.9867 76.7324 79.3995 76.4948 81.5922 75.5865C83.7849 74.6783 85.6591 73.1402 86.9776 71.1668C88.2962 69.1935 89 66.8734 89 64.5C89 61.3174 87.7357 58.2652 85.4853 56.0147C83.2348 53.7643 80.1826 52.5 77 52.5ZM77 74.3182C75.0582 74.3182 73.1599 73.7424 71.5453 72.6635C69.9307 71.5847 68.6723 70.0513 67.9292 68.2573C67.1861 66.4632 66.9916 64.4891 67.3705 62.5846C67.7493 60.68 68.6844 58.9306 70.0575 57.5575C71.4306 56.1844 73.18 55.2493 75.0846 54.8705C76.9891 54.4916 78.9632 54.6861 80.7573 55.4292C82.5513 56.1723 84.0847 57.4307 85.1635 59.0453C86.2424 60.6599 86.8182 62.5581 86.8182 64.5C86.8182 67.1039 85.7838 69.6012 83.9425 71.4425C82.1012 73.2838 79.6039 74.3182 77 74.3182Z",
    fill: "#F8AFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTransaction);
export default __webpack_public_path__ + "static/media/empty_transaction.eeadb5062f108c5efb26f8405910a3be.svg";
export { ForwardRef as ReactComponent };